import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function Container({
  children,
  className,
  size = "default",
}: {
  children: ReactNode;
  className?: string;
  size?: "default" | "narrow" | "wide";
}) {
  return (
    <div
      className={cn(
        "mx-auto w-full px-5 sm:px-6 lg:px-8",
        size === "default" && "max-w-[1280px]",
        size === "narrow" && "max-w-[840px]",
        size === "wide" && "max-w-[1440px]",
        className
      )}
    >
      {children}
    </div>
  );
}
